<template>
  <div class="wrapper" :style="{ right: visible ? 0 : '-64px' }">
    <div class="list">
      <div class="item">
        <Label />
      </div>

      <div class="item">
        <SearchLocation />
      </div>

      <div class="item">
        <GetDistance />
      </div>
      <div class="item">
        <GetArea />
      </div>
      <div class="item">
        <SnapShot />
      </div>

      <div class="divider"></div>

      <div class="item">
        <Max />
      </div>
      <div class="item">
        <Min />
      </div>
      <div class="item">
        <Move />
      </div>
      <!-- <div class="item">
        <Layer />
      </div>-->
    </div>
    <div class="menu" @click="visible = !visible">
      <a-icon type="setting" />
    </div>
  </div>
</template>

<script>
import Label from "./label.vue";
import SearchLocation from "./search-location.vue";
import GetDistance from "./get-distance.vue";
import GetArea from "./get-area.vue";
import SnapShot from "./snapshot.vue";
import Max from "./max.vue";
import Min from "./min.vue";
import Move from "./move.vue";
// import Layer from "./layer.vue";
export default {
  components: {
    Label,
    SearchLocation,
    GetDistance,
    GetArea,
    SnapShot,
    Max,
    Min,
    Move,
    // Layer,
  },
  data() {
    return {
      visible: false,
    };
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  position: fixed;
  top: 20%;
  right: 0;
  z-index: 99;
  transition: all 0.5s;
}
.list {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 0;
  width: 64px;

  .item {
    cursor: pointer;
  }

  .divider {
    height: 1px;
    background-color: rgb(215, 214, 214);
  }
}
.menu {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -32px;
  background-color: #fff;
  color: #999;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>